import { useEffect, useMemo, useState } from "react";
import { filterAddresses } from "../functions/filterAddresses";
import { strLang } from "../functions/strLang";
import { colorsList } from "../data/colorsList";

export default function useSearch({ addresses, openMap }) {
  const [open, setOpen] = useState(false);
  const [selectedPoint, setSelectedPoint] = useState({
    terId: false,
    terName: false,
    point: false,
    name: false,
  });
  const [mainTxt, setMainTxt] = useState("");
  const list = useMemo(() => filterAddresses(addresses, mainTxt), [mainTxt]);

  useEffect(() => {
    closeMsg();
  }, [addresses, list]);

  const closeMsg = () => {
    setOpen(false);
    setSelectedPoint({ id: false, name: false });
  };

  const msgType = {
    openPoint: {
      title: strLang("openThisPoint"),
      label: selectedPoint.name,
      buttons: [
        {
          label: strLang("open"),
          func: () => {
            openMap({
              id: selectedPoint.terId,
              name: selectedPoint.terName,
              point: selectedPoint.point,
              screen: "map",
            });
            closeMsg();
          },
          width: 80,
        },
        {
          label: strLang("cancel"),
          func: closeMsg,
          width: 80,
          color: colorsList.darkGrey,
        },
      ],
    },
    loading: {
      type: "loading",
    },
    error: {
      type: "error",
      label: strLang("netWorkError"),
    },
  };

  return {
    list,
    open,
    setOpen,
    mainTxt,
    setMainTxt,
    msgType,
    closeMsg,
    setSelectedPoint,
  };
}
